import React from "react";

import "./video.css";

import SchoolEntryVideo from "../../assets/home/school-720.mp4";

const SchoolEntry = () => {
  return (
    <div className={"container-fluid stMarounVideo"}>
      <div className={"row"}>
        <div className={"col d-flex p-2"}>
          <video autoPlay="autoPlay" muted loop="loop" id="myVideo">
            <source src={SchoolEntryVideo} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default SchoolEntry;
